import { useRoutingContext } from './useRoutingContext'

export const usePage = () => {
	const routingContext = useRoutingContext()

	return routingContext.page
}
